import { pubPageAdTargeting } from "@config/AdsConstants";
import Advertisement from "@elements/Advertisement/Advertisement";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import {
  AdTargetingType,
  AdvertisementTypeEnum,
  PageAdTargetValue,
} from "@typings/Ads.d";
import { twMerge } from "tailwind-merge";
/**
 * TM LB1 Ad
 * Description: The adsLb1 component for rendering ads.
 * @name - name of section or page
 * @index - use when lb1 is rendered more than 1
 */
export function AdsLb1({
  sectionName,
  index,
  pageAdTargetType,
  gsChannels,
  containerClass,
}: {
  sectionName?: string;
  index?: number;
  pageAdTargetType: PageAdTargetValue;
  gsChannels?: string[];
  containerClass?: string;
}) {
  const PubPageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;

  if (sectionName === "/") {
    sectionName = "Home";
  }
  return (
    <div
      className={twMerge(
        "flex flex-col xl:flex-row items-center justify-center max-w-full pb-xxs lg:pb-5 min-h-[80px] lg:min-h-[120px] bg-white-100",
        containerClass,
      )}
    >
      <Advertisement
        adUnitProps={{
          type: AdvertisementTypeEnum.LB1,
          slot: GoogleAdsSlotFactory.lb1(sectionName),
          id: index ? `dfp-ad-lb1-${index}` : "dfp-ad-lb1",
          rootClassName:
            "flex items-center [&_iframe]:max-w-screens-md sm:max-w-full",
          pubAdTargeting: [PubPageAdTarget],
          gsChannels,
        }}
      />
    </div>
  );
}
